export enum SmartZoneSendState{
  CheckPolygon = 0,
  WaitingForGreyListCreation = 1,
  EnsureGreyListCreated = 2,
  ReadyToCreateSend = 3,
  Refreshing = 4,
  WaitingForMessageEntry = 5,
  WaitingForRecipientSelection = 6,
  WaitingForAdminManualReview = 7,
  WaitingForPayment = 8,
  WaitingForAdminManualPaymentReview = 9,
  Paid = 10,
  SentToProvider = 11,
  Finished = 12,
  Rejected = 13,
  Failed = 14,
  Expired = 15,
  WaitingForUserConfirmation = 16
}

export enum TargetTime{
  Past = 1,
  Future = 2
}

export enum SmartZoneSendMobileOs {
  Android = 1,
  IOS = 2,
  Other = 4
}

export enum SmartZoneSendResidenceState {
  Resident = 1,
  Guest = 2
}
